import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { Bell } from "lucide-react";
import { fmtDate } from "./admin/leadUtils";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const NotificationBell = () => {
  const [data, setData] = useState({ items: [], unread: 0 });
  const [open, setOpen] = useState(false);

  const fetchAll = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/notifications`, { withCredentials: true });
      setData(res.data);
    } catch { /* not signed in */ }
  }, []);

  useEffect(() => {
    fetchAll();
    const t = setInterval(fetchAll, 60000);
    return () => clearInterval(t);
  }, [fetchAll]);

  const toggle = async () => {
    const next = !open;
    setOpen(next);
    if (next) {
      fetchAll();
      if (data.unread > 0) {
        try {
          await axios.post(`${API}/notifications/mark-read`, {}, { withCredentials: true });
          setData((d) => ({ ...d, unread: 0, items: d.items.map((i) => ({ ...i, read: true })) }));
        } catch { /* keep badge if mark-read failed */ }
      }
    }
  };

  const onItemClick = (e, n) => {
    if (!n.link || window.location.pathname === n.link) e.preventDefault();
    setOpen(false);
  };

  return (
    <div className="relative">
      <button data-testid="notification-bell" onClick={toggle} className="relative p-2 border border-zinc-800 rounded-sm text-zinc-400 hover:text-white transition-colors">
        <Bell className="h-4 w-4" />
        {data.unread > 0 && (
          <span data-testid="notification-badge" className="absolute -top-1.5 -right-1.5 bg-red-600 text-white text-[10px] font-bold rounded-full min-w-[18px] h-[18px] flex items-center justify-center px-1">
            {data.unread > 99 ? "99+" : data.unread}
          </span>
        )}
      </button>
      {open && <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />}
      {open && (
        <div data-testid="notification-dropdown" className="absolute right-0 mt-2 w-80 max-h-96 overflow-y-auto bg-[#121212] border border-zinc-800 rounded-xl shadow-2xl z-50 p-2">
          {data.items.length === 0 ? (
            <p className="text-zinc-600 text-xs text-center py-6">No notifications yet.</p>
          ) : data.items.map((n) => (
            <a key={n.id} href={n.link || "#"} onClick={(e) => onItemClick(e, n)} className={`block rounded-sm p-2.5 mb-1 border ${n.read ? "border-transparent" : "border-blue-500/30 bg-blue-500/5"} hover:bg-zinc-800/50`}>
              <div className="text-white text-xs font-semibold">{n.title}</div>
              <div className="text-zinc-400 text-xs mt-0.5">{n.message}</div>
              <div className="text-zinc-600 text-[10px] mt-1">{fmtDate(n.created_at)}</div>
            </a>
          ))}
        </div>
      )}
    </div>
  );
};
